module.exports = __webpack_public_path__ + "img/null-bg-no-result.04ab6eb0.svg";